<div class="w-full">
  <div class="w-full h-4 bg-transparent rounded-sm hover:cursor-pointer" ref="tooltipBtn">
    <div class="h-4 rounded-sm" :style="{width: `${value}%`, 'background-color': `${color}`}"></div>
  </div>
  <div ref="tooltipContent" role="tooltip"
    class="inline-block absolute invisible z-10 py-2 px-3 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm opacity-0 transition-opacity duration-300 tooltip dark:bg-gray-700">
    {{tooltip}}
    <div class="tooltip-arrow" data-popper-arrow></div>
  </div>
</div>